exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ImageDouble-module__ImageDouble___1Z91l{display:grid;grid-template-columns:1fr 1fr;gap:24px}@media (max-width:500px){.ImageDouble-module__ImageDouble___1Z91l{grid-template-columns:1fr}}.ImageDouble-module__ImageDouble___1Z91l .ImageDouble-module__image___1qSnK{width:100%;padding-bottom:68%;position:relative;border-radius:6px;overflow:hidden}.ImageDouble-module__ImageDouble___1Z91l .ImageDouble-module__image___1qSnK img{height:100%;width:100%;-o-object-fit:contain;object-fit:contain;position:absolute}", ""]);

// exports
exports.locals = {
	"ImageDouble": "ImageDouble-module__ImageDouble___1Z91l",
	"image": "ImageDouble-module__image___1qSnK"
};